import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import CircularProgress from '@material-ui/core/CircularProgress';

import InputSelect from '~/components/Input/InputSelect';
import Button from '~/components/Button';
import InputDate from '~/components/Input/InputDate';
import InputControl from '~/components/Input/InputControl';
import Dialog from '~/components/Dialog';

const EditPackageModal = ({
  isOpen,
  handleClose,
  actualPackage,
  cancelDate,
  setCancelDate,
  handleSave,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      icon={<PlaylistAddIcon />}
      isOpen={isOpen}
      handleClose={handleClose}
      title={`${t('person.extras.edit_package')}`}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
        }}
      >
        <InputControl
          name={'pack_name'}
          label={t('person.attributes.pack')}
          inputComponent={InputSelect}
          disabled
          value={
            actualPackage?.pack_type === 'pack'
              ? 'Pacote'
              : actualPackage?.pack_type === 'doctor_all'
              ? 'Médico especialista'
              : 'TELEVIDA Médico'
          }
          InputProps={{
            isClearable: false,
            createEnabled: false,
          }}
        />
        <InputControl
          name={'specialty_name'}
          label={t('person.attributes.packPackages')}
          inputComponent={InputSelect}
          disabled
          value={actualPackage?.pack_name ?? '-'}
          InputProps={{
            isClearable: false,
            createEnabled: false,
          }}
        />
        <div>
          <InputControl
            name="date"
            label={t('person.attributes.cancel_date')}
            value={moment(cancelDate).format()}
            disabled={!actualPackage?.pack_id}
            inputComponent={InputDate}
            onBlur={() => {}}
            InputProps={{
              type: 'date',
            }}
            onChange={(date) => setCancelDate(moment(date).format())}
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button disabled={!actualPackage?.pack_id} type="submit">
            SALVAR
          </Button>
        </div>
      </form>
      {isLoading && (
        <CircularProgress
          size={24}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
          }}
        />
      )}
    </Dialog>
  );
};

EditPackageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  actualPackage: PropTypes.object.isRequired,
  handleSave: PropTypes.func.isRequired,
  cancelDate: PropTypes.string.isRequired,
  setCancelDate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default React.memo(EditPackageModal);
